import router from '@/router/router'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faArrowLeft,
    faArrowRight,
    faAward,
    faBan,
    faBars,
    faBell,
    faBook,
    faBookOpen, faCalendarDays,
    faCamera,
    faCaretDown,
    faCircleArrowUp,
    faCircleExclamation,
    faCircleInfo,
    faCloudArrowUp,
    faCommentDots,
    faComments,
    faDownload,
    faEllipsis,
    faEnvelope,
    faEraser,
    faEye,
    faFilter,
    faFilterCircleXmark,
    faFlag,
    faGift, faHandHolding, faHandHoldingHand,
    faHouse,
    faLink,
    faMagnifyingGlass,
    faPaperPlane,
    faRightFromBracket,
    faTag,
    faStar,
    faTrophy,
    faMedal,
    faRankingStar,
    faThumbsDown,
    faThumbsUp,
    faTrash,
    faUpload,
    faUser,
    faUserGear,
    faUsers
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { createPinia } from 'pinia'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Button from 'primevue/button'
import Calendar from 'primevue/calendar'
import Card from 'primevue/card'
import Carousel from 'primevue/carousel'
import Checkbox from 'primevue/checkbox'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ConfirmDialog from 'primevue/confirmdialog'
import Dialog from 'primevue/dialog'
import DialogService from 'primevue/dialogservice'
import Divider from 'primevue/divider'
import Dropdown from 'primevue/dropdown'
import DynamicDialog from 'primevue/dynamicdialog'
import Fieldset from 'primevue/fieldset'
import FileUpload from 'primevue/fileupload'
import InputNumber from 'primevue/inputnumber'
import InputText from 'primevue/inputtext'
import Listbox from 'primevue/listbox'
import Menu from 'primevue/menu'
import Menubar from 'primevue/menubar'
import MultiSelect from 'primevue/multiselect'
import Password from 'primevue/password'
import ScrollPanel from 'primevue/scrollpanel'
import TabPanel from 'primevue/tabpanel'
import TabView from 'primevue/tabview'
import Textarea from 'primevue/textarea'
import Toast from 'primevue/toast'
import Sidebar from 'primevue/sidebar'
import ToastService from 'primevue/toastservice'
import { createApp } from 'vue'
import App from './App.vue'
import './assets/sass/style.scss'
import i18n from './i18n'
import Tooltip from 'primevue/tooltip'
import { defineCustomElements } from '@ionic/pwa-elements/loader'
import { App as CapacitorApp } from '@capacitor/app'
import StyleClass from 'primevue/styleclass'

import 'chart.js/auto';
import Chart from 'primevue/chart'
import { Vue3Mq } from "vue3-mq"
import Ripple from 'primevue/ripple';
import 'primeicons/primeicons.css'
import 'primevue/resources/primevue.min.css'

import tipDirective from '@/directives/tipDirective'

const pinia = createPinia()
const app = createApp(App)

app.use(PrimeVue, { ripple: true });
app.use(router)
app.use(pinia)
app.use(i18n)
app.use(ToastService)
app.use(ConfirmationService)
app.use(DialogService)
app.use(Vue3Mq, {
    breakpoints: {
        mobile: 0,
        tablet: 550,
        desktop: 991
    }
})

app.directive('tooltip', Tooltip)
app.directive('ripple', Ripple);
app.directive('styleclass', StyleClass)
app.directive('tip', tipDirective)

app.component('font-awesome-icon', FontAwesomeIcon)
app.component('Button', Button)
app.component('Dialog', Dialog)
app.component('InputText', InputText)
app.component('InputNumber', InputNumber)
app.component('Divider', Divider)
app.component('Password', Password)
app.component('Calendar', Calendar)
app.component('Dropdown', Dropdown)
app.component('Checkbox', Checkbox)
app.component('Carousel', Carousel)
app.component('Menubar', Menubar)
app.component('Menu', Menu)
app.component('Card', Card)
app.component('MultiSelect', MultiSelect)
app.component('Toast', Toast)
app.component('ConfirmDialog', ConfirmDialog)
app.component('Accordion', Accordion)
app.component('AccordionTab', AccordionTab)
app.component('FileUpload', FileUpload)
app.component('Textarea', Textarea)
app.component('DynamicDialog', DynamicDialog)
app.component('Listbox', Listbox)
app.component('ScrollPanel', ScrollPanel)
app.component('TabView', TabView)
app.component('TabPanel', TabPanel)
app.component('Fieldset', Fieldset)
app.component('Sidebar', Sidebar)
app.component('Chart', Chart)

library.add(faTag, faGift, faHandHolding, faHandHoldingHand, faCaretDown, faCommentDots,
    faPaperPlane, faEnvelope, faCircleArrowUp, faBell, faMagnifyingGlass, faFilterCircleXmark,
    faBookOpen, faCalendarDays, faEllipsis, faArrowRight, faFilter, faEraser, faCloudArrowUp,
    faUserGear, faRightFromBracket, faBook, faHouse, faUsers, faUser, faUpload, faBan, faDownload, faThumbsUp,
    faCamera, faStar,faTrophy,faMedal, faRankingStar, faCircleInfo, faThumbsDown, faTrash, faFlag, faMagnifyingGlass, faArrowLeft, faBars, faLink,
    faEye, faComments, faCircleExclamation, faAward)

app.mount('#app')

defineCustomElements(window)

CapacitorApp.addListener('backButton', ({ canGoBack }) => {
    if (!canGoBack) {
        CapacitorApp.exitApp()
    } else {
        window.history.back()
    }
})
